import {
    AttributeQueryParams,
    AttributeValuesQueryParams,
} from '../../models/contact_attributes.model';

const attributeKeys = {
    attributes: ['attributes'],
    attributeOperators: ['attributes', 'operators'],
    attributeValues: (id: number, params?: AttributeValuesQueryParams) => [
        'attributes',
        id,
        'values',
        params?.page,
        params?.per_page,
        params?.value_name,
    ],
    attributeValuesForSelect: (
        id: number,
        params?: AttributeValuesQueryParams,
    ) => ['attributes', id, 'values', params?.value_name],
    attributesParams: (params: AttributeQueryParams) => [
        'attributes',
        params.is_active,
        params.page,
        params.per_page,
        params.attribute_name,
        params.attribute_type,
        params.status,
    ],
    attributesParamsForSelect: (params: AttributeQueryParams) => [
        'attributes',
        params.is_active,
        params.attribute_name,
    ],
};

export default attributeKeys;
